"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formHelpers = void 0;
var mapBooleanToRadioValue = function mapBooleanToRadioValue(value) {
  if (value === null || value === undefined || typeof value !== 'boolean') {
    return value;
  }
  return value ? 'yes' : 'no';
};
var mapRadioValueToBoolean = function mapRadioValueToBoolean(value) {
  if (value === 'yes') {
    return true;
  }
  if (value === 'no') {
    return false;
  }
  return value;
};
var formHelpers = exports.formHelpers = {
  mapBooleanToRadioValue: mapBooleanToRadioValue,
  mapRadioValueToBoolean: mapRadioValueToBoolean
};